import React, { useState,useEffect,useRef } from "react";
import { useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import { updateShipmentStatus,updateShipmentIssue,closeShipment,openShipment } from "../../store/features/shipmentsSlice";
import NotificationModal from "../Notification/Notify";
import ConfirmationModal from "../Notification/Confirm";

const CaseHeader = ({ caseId, shipmentId, origin, destination, carrier, trackingNumber }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalConfig, setModalConfig] = useState({});
  const [notification, setNotification] = useState({ isOpen: false, message: "" });
  const [automationEnabled, setAutomationEnabled] = useState(true);
  const [dropdownVisible, setDropdownVisible] = useState(false);
  const dropdownRef = useRef(null); // Ref for the dropdown
  const location = useLocation(); // Get current path
  const dispatch = useDispatch();

  const handleToggleAutomation = () => {
    setAutomationEnabled((prev) => !prev);
  };

  const toggleDropdown = () => {
    setDropdownVisible((prev) => !prev);
  };

  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setDropdownVisible(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);


  const handleCloseCase = () => {
    setModalConfig({
      title: "Close Case",
      message: "Are you sure you want to close this case?",
      onConfirm: async () => {
        try {
          await dispatch(closeShipment(caseId));
          setNotification({ isOpen: true, message: "Case closed successfully!" });
          setTimeout(async () => {window.location.href = "/dashboard";}, 2000);
        } catch (error) {
          console.error("Failed to close the case:", error);
          setNotification({ isOpen: true, message: "Failed to close the case. Please try again." });
        }
        setIsModalOpen(false);
      },
    });
    setIsModalOpen(true);
  };

  const handleOpenCase = () => {
    setModalConfig({
      title: "Reopen Case",
      message: "Are you sure you want to reopen this case?",
      onConfirm: async () => {
        try {
          await dispatch(openShipment(caseId));
          setNotification({ isOpen: true, message: "Case reopened successfully!" });
          setTimeout(async () => {window.location.href = "/dashboard";}, 1500);
        } catch (error) {
          console.error("Failed to reopen the case:", error);
          setNotification({ isOpen: true, message: "Failed to reopen the case. Please try again." });
        }
        setIsModalOpen(false);
      },
    });
    setIsModalOpen(true);
  };

  const isArchived = location.pathname.startsWith("/archived");
  console.log({isArchived})
  return (
    <div className="mb-6">
      {/* Header Section */}
      <div className="flex justify-between items-start">
        <div>
          {/* Breadcrumb */}
          <div className="flex items-center gap-2 mb-4 text-font-LIGHT">
            <a href="/dashboard" className="text-font-LIGHT underline hover:text-logo">
              Home
            </a>

            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth="1.5"
              stroke="currentColor"
              className="w-4 h-4"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="m8.25 4.5 7.5 7.5-7.5 7.5"
              />
            </svg>
            
            <span>Case #{caseId} - Shipment Overview</span>
          </div>

          {/* Case Header */}
          <h1 className="text-2xl font-bold mb-2">Shipment Overview</h1>
          <p>
            <strong>Shipment ID:</strong> {shipmentId}{" "}
            <strong>Origin:</strong> {origin}{" "}
            <strong>Destination:</strong> {destination}{" "}
            <strong>Carrier:</strong> {carrier}{" "}
            <strong>Tracking Number:</strong> {trackingNumber}
          </p>
        </div>

        {/* Top Right Corner */}
       
        <div className="flex flex-col items-end space-y-4">
          {/* Automation Toggle */}
          {/*
          <div className="flex items-center gap-2">
            <label className="flex items-center gap-2 cursor-pointer">
              <span className="text-sm font-medium">
                {automationEnabled ? "Automation On" : "Automation Off"}
              </span>
              <input
                type="checkbox"
                className="sr-only peer"
                checked={automationEnabled}
                onChange={handleToggleAutomation}
              />
              <div className="w-10 h-5 bg-gray-200 rounded-full peer-checked:bg-green-500 relative">
                <div
                  className={`w-4 h-4 bg-white rounded-full shadow transition-transform duration-300 transform absolute top-0.5 ${
                    automationEnabled ? "translate-x-5" : "translate-x-0"
                  }`}
                ></div>
              </div>
            </label>
            </div>
            */}

          {/* Actions Dropdown */}
        <div className="relative" ref={dropdownRef}>
          <button
            onClick={toggleDropdown}
            className="border border-2 border-logo text-lg bg-white text-logo px-4 py-2 rounded-full hover:bg-logo hover:text-white flex items-center space-x-2"
          >
            <span>Actions</span>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              className={`w-5 h-5 ${
                dropdownVisible ? "rotate-180" : "rotate-0"
              }`}
            >
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 9l6 6 6-6" />
            </svg>
          </button>

          {dropdownVisible && (
            <div className="absolute right-0 mt-2 w-56 bg-white border border-gray-200 rounded-lg shadow-lg">
              {isArchived ? (
                // Show Open Case option if on "archived" path
                <button
                  onClick={handleOpenCase}
                  className="block w-full px-4 py-2 text-left text-gray-800 hover:bg-gray-100 hover:text-gray-900 transition duration-200"
                >
                  Open Case
                </button>
              ) : (
                // Show Close Case option otherwise
                <button
                  onClick={handleCloseCase}
                  className="block w-full px-4 py-2 text-left text-gray-800 hover:bg-gray-100 hover:text-gray-900 transition duration-200"
                >
                  Close Case
                </button>
              )}
            </div>
          )}
          <ConfirmationModal
            isOpen={isModalOpen}
            title={modalConfig.title}
            message={modalConfig.message}
            onConfirm={modalConfig.onConfirm}
            onCancel={() => setIsModalOpen(false)}
          />
          {/* Notification Modal */}
          <NotificationModal
            isOpen={notification.isOpen}
            message={notification.message}
            onClose={() => setNotification({ isOpen: false, message: "" })}
          />
        </div>
        </div>
      </div>
    </div>
  );
};


export default CaseHeader;